export default {
  itemsPerPage: [
    { value: 5 },
    { value: 10 },
    { value: 15 },
    // { value: 50 },
    // { value: 100 },
    // { value: 500 },
  ],
};



// WEBPACK FOOTER //
// ./src/vuestic-theme/vuestic-components/vuestic-datatable/data/items-per-page-definition.js